export function localStorageAvailable(): boolean {
    try {
        window.localStorage.setItem('testKey', 'test');
        window.localStorage.removeItem('testKey');
        return true;
    } catch (e) {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/_helpers/local-storage-available.ts